import React from "react";
import Aux from "../AuxFunctions";
import Colors from "../Colors"
import Fire from "../../config/Fire";
import moment from "moment";
import {  withRouter } from 'react-router-dom'

class SingleMessage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            user: {},
            userUid: "",
            loadingUser: false,
            lastMessage: {},
            newMessage: false,
        }
    }

    componentDidMount() {
        try {
            //this.getUserInfo();
            //this.createMessagesListener()
            //this.setState({lastMessage: this.props.message.lastMessage})
            const found = this.props.message?.users.find(user => user !== Fire.shared.uid)
            if(found){
                this.setState({userUid: found})
                this.getUserInfo(found)
            } 
        } catch (error) {
            Aux.handleError(error)
        }
    }

    componentWillUnmount(){
        if(this.messagesListener)
            this.messagesListener()
    }

    messagesListener = null;
    createMessagesListener = () => {
        try {
            this.messagesListener = Fire.shared.firestore
                .collection('chats')
                .doc(this.props.message.id)
                .onSnapshot(snapshot => {
                    if (snapshot) {
                        if(snapshot.data().lastMessage?.text !== this.props.message.lastMessage?.text){
                            console.log("modifiedd")
                            this.setState({lastMessage: snapshot.data().lastMessage, newMessage:true})
                        }
                    } else {
                        this.setState({ finished: true, loading: false })
                    }
                })
        } catch (error) {
            Aux.handleError(error)
        }
    }

    getUserInfo = async (uid) => {
        try {
            this.setState({loadingUser:true})
            let userQuery = await Fire.shared.firestore.collection("users").doc(uid).get();
            if (userQuery.exists) {
                this.setState({ user: userQuery.data(), loadingUser:false })
            }else{
                this.setState({noUserFound: true, loadingUser:false})
            }
            
        } catch (error) {
            Aux.handleError(error)
            this.setState({loadingUser:false})
        }
    }

    getTime = () => {
        if(this.props.message.lastMessage?.timestamp){
            return moment(this.props.message.lastMessage.timestamp.toDate()).fromNow();
        }else if(this.props.message?.timestamp){
            return moment(this.props.message.timestamp.toDate()).fromNow();
        }else{
            return null
        }
    }

    getLastMessage = () => {
        if(this.state.lastMessage?.text){
            return this.props.message.lastMessage.text;
        }else 
            return "You've matched"
    }


    goToMessage = () => {
        //this.props.history.push(`/message/${this.props.message.id}`,{user:this.state.user})
        this.props.history.push({pathname: `/message/${this.props.message.id}`,
        state: { user: this.state.user, message: this.props.message }})
    }

    isLastMessage = () => {
        if(this.props.message.lastMessage?.from !== Fire.shared.uid){
            if(!this.props.message.lastMessage?.read){
                return true
            }
        }
        return false
    }

    render() {
        return (
            <div onClick={this.goToMessage}>
                <div style={{padding:"20px 10px", cursor:"pointer", display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                <div style={{ display: "flex", flexDirection: "row", overflow:"hidden" }}>
                    {Aux.showAvatar(45, this.state.user?.avatar,  this.state.user.username || "Unknown")}
                    <div style={{marginLeft:10, overflow:"hidden"}}>
                        <div>
                            <span style={{ flex: 1, fontWeight: "bold", fontSize: 15, color: Colors.darkText, width: 100, overflowWrap:"anywhere" }}
                            /*onPress={() => {this.props.navigation.navigate("ViewProfile", { uid: this.props.notification.uid });}}*/>
                                {this.state.user?.username || "Unknown"}
                            </span>
                        </div>
                        <div style={{display:"flex", overflow:"hidden"}}>
                            <div style={{display:"flex", overflow:"hidden", textOverflow:"ellipsis", flex:1}}>
                            <span style={{ overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", fontWeight: this.isLastMessage() ? "bold" : "500", fontSize:16, color: this.isLastMessage() ? Colors.darkText : Colors.middleText }}>
                                {this.props.message.lastMessage.text || "You've matched"}
                            </span>
                            </div>
                            <div style={{ overflow:"hidden", whiteSpace:"nowrap", marginLeft:10}}>
                            <span style={{ fontWeight: "500", fontSize: 14, color: Colors.softText, overflow:"hidden", textOverflow:"ellipsis" }}>
                                {this.getTime()}
                            </span>
                            </div>
                        </div>
                    </div>
                    {/* <this.RenderPostImage></this.RenderPostImage> */}
                </div>
                {this.isLastMessage() ?
                    <div style={{borderRadius:"50%", height:10, width:10, backgroundColor:"red"}}></div>
                : null}
            </div>
            
            </div>
        )
    }
}

export default withRouter(SingleMessage)

